import { bootstrapApplication } from '@angular/platform-browser';

import { setRootInjector } from '@kp/utils';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

type StructuredCloneGlobal = {
  structuredClone?: <T>(value: T, options?: StructuredSerializeOptions) => T;
} & typeof globalThis;

const globalScope = globalThis as StructuredCloneGlobal;

// It is fallback to devices where structuredClone is not supported
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
if (!globalScope.structuredClone) {
  globalScope.structuredClone = <T>(value: T): T => {
    // oxlint-disable-next-line unicorn/prefer-structured-clone
    const clonedValue: unknown = JSON.parse(JSON.stringify(value));

    // The fallback preserves the generic browser API shape for runtimes
    // where native structuredClone is not available.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
    return clonedValue as T;
  };
}

try {
  const moduleRef = await bootstrapApplication(AppComponent, appConfig);
  setRootInjector(moduleRef.injector);
} catch (error: unknown) {
  console.error(error);
}
